import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GenericService } from './generic.service';
import { UsersService } from './users.service';
import { ServerResponse } from '../models/ServerResponse';
import { Observable } from 'rxjs';
import { IGroupingElectricityPrice, IGroupingPrice, IPrice } from '../models/Price';
import { FilterOperator, ISAPI, ISFilterAPI, ISPagination, MVFilter, MVListingConfigs, MVOrdering } from 'is-lib';
import { IElectricityMetersTotalConsumptionPT, INaturalGasMetersTotalConsumption } from '../models/Consumptions';
import { IElectricityOmipPricesPT, INaturalGasOmipPricesPT } from '../models/OmipPrice';

@Injectable({
    providedIn: 'root'
})
export class PriceService {
    
constructor(private _httpService: GenericService, private _user: UsersService) { }

    getPrice(groupingPriceId: string, callLoader: boolean = true): Observable<ServerResponse<IGroupingPrice>> {
        return this._httpService.get(`${environment.apiUrl}GroupingPrices/${groupingPriceId}`, callLoader);
    }

    getPricesByGrouping(groupingId: string, body?: ISAPI, callLoader: boolean = true): Observable<ServerResponse<IPrice[]>> {
        if (!body) {
            body = new ISAPI( [], new ISPagination(100, 0) );
        }

        return this._httpService.post(`${environment.apiUrl}Groupings/${groupingId}/Prices`, body, undefined, callLoader);
    }

    getElectricityOMIPPrices(body?: ISAPI): Observable<ServerResponse<any[]>> {
        if (!body) {
            body = new ISAPI( [], new ISPagination(100, 0) );
        }

        return this._httpService.post(`${environment.apiUrl}OmipPrices/${this._user.userCountryCode}/Electricity/Get`, body, undefined);
    }

    getNaturalGasOMIPPrices(body?: ISAPI): Observable<ServerResponse<any[]>> {
        if (!body) {
            body = new ISAPI( [], new ISPagination(100, 0) );
        }

        return this._httpService.post(`${environment.apiUrl}OmipPrices/${this._user.userCountryCode}/NaturalGas/Get`, body, undefined);
    }

    getElectricityOMIPPrice(priceId: string): Observable<ServerResponse<IElectricityOmipPricesPT>> {
        return this._httpService.get(`${environment.apiUrl}OmipPrices/${this._user.userCountryCode}/Electricity/${priceId}`, undefined, undefined);
    }

    getNaturalGasOMIPPrice(priceId: string): Observable<ServerResponse<INaturalGasOmipPricesPT>> {
        return this._httpService.get(`${environment.apiUrl}OmipPrices/${this._user.userCountryCode}/NaturalGas/${priceId}`, undefined, undefined);
    }

    getElectricityGroupingPriceTotalConsumption(groupingPriceId: string, body?: ISAPI, callLoader: boolean = true): Observable<ServerResponse<IElectricityMetersTotalConsumptionPT[]>> {
        if (!body) {
            body = new ISAPI( [], new ISPagination(100, 0) );
        }

        return this._httpService.post(`${environment.apiUrl}GroupingPrices/${groupingPriceId}/${this._user.userCountryCode}/ElectricityGroupings/TotalConsumptions`, body, undefined, callLoader);
    }

    getNaturalGasGroupingPriceTotalConsumption(groupingPriceId: string, body?: ISAPI, callLoader: boolean = true): Observable<ServerResponse<INaturalGasMetersTotalConsumption[]>> {
        if (!body) {
            body = new ISAPI( [], new ISPagination(100, 0) );
        }

        return this._httpService.post(`${environment.apiUrl}GroupingPrices/${groupingPriceId}/${this._user.userCountryCode}/NaturalGasGroupings/TotalConsumptions`, body, undefined, callLoader);
    }

    getGroupingPriceElectricityGroupings(groupingPriceId: string, callLoader: boolean = true): Observable<ServerResponse<any[]>> {
        return this._httpService.get(`${environment.apiUrl}GroupingPrices/${groupingPriceId}/${this._user.userCountryCode}/ElectricityGroupings`, callLoader);
    }

    getGroupingPriceNaturalGasGroupings(groupingPriceId: string, callLoader: boolean = true): Observable<ServerResponse<any[]>> {
        return this._httpService.get(`${environment.apiUrl}GroupingPrices/${groupingPriceId}/${this._user.userCountryCode}/NaturalGasGroupings`, callLoader);
    }

    getElectricityPricesForPortal(body?: any, callLoader: boolean = true): Observable<ServerResponse<any[]>> {
        return this._httpService.post(`${environment.apiUrl}ClientPortalUsers/${this._user.userCountryCode}/ElectricityPrices/Get`, body, undefined, callLoader);
    }

    // getNaturalGasPricesFromPricePeriod( pricePeriodId: string, body?: ISAPI, callLoader: boolean = true): Observable<ServerResponse<any[]>> {
    //     if (!body) {
    //         body = new ISAPI( [], new ISPagination(100, 0) );
    //     }

    //     return this._httpService.post(`${environment.apiUrl}PricePeriods/${pricePeriodId}/${this._user.userCountryCode}/NaturalGasPrices/EnergyFixedPrices`, body, undefined, callLoader);
    // }
}